import React from 'react';
import { Link } from 'react-router-dom';

export function PaymentCancelled() {

    return (
        <section id="PaymentCancelled">
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Payment Cancelled</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">

                                        <div className="theme-color text-center">
                                            <p>
                                                You have cancelled your payment. No amount was charged to your account.
                                            </p>
                                        </div>
                                        <div className="text-center mt-3">

                                            <Link to={'/'} className="btn btn-primary">Home</Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





